const CONTENT_TYPES = {
  aac: ['audio/aac'],
  flac: ['audio/flac', 'audio/x-flac'],
  m4a: ['audio/mp4', 'audio/x-m4a'],
  mp3: ['audio/mpeg', 'audio/mp3'],
  ogg: ['audio/ogg'],
  opus: ['audio/opus', 'audio/ogg'],
  wav: ['audio/wav', 'audio/x-wav', 'audio/wave'],
};

export const getJianyingAudioContentType = (file = {}) => {
  const extension = String(file.name || '')
    .split('.')
    .pop()
    ?.toLowerCase();
  const allowed = CONTENT_TYPES[extension];
  if (!allowed) throw new Error('不支持该音频文件格式');
  const supplied = String(file.type || '').toLowerCase();
  return allowed.includes(supplied) ? supplied : allowed[0];
};
